const module = { name: 'movie/shared/datePicker', exports: {} }; const exports = module.exports;



import { Fandango_util as Fandango_util_formatDate } from 'require-global';

const { formatDate } = Fandango_util_formatDate;


const Selectors = {
    DATE_PICKER_LIST: 'scroll-date-picker__list',
    DATE_WEEKDAY: '.date-picker__date-weekday'
}


const DataAttribs = {
    DATE: 'data-show-time-date'
}


const Styles = {
    SELECTED_DATE: 'fd-carousel--last-selected'
}
function markToday(containerId) {
    const container = document.getElementById(containerId || Selectors.DATE_PICKER_LIST);
    if (!container) {
        return;
    }
    const today = formatDate(new Date());
    const todaysEl = container.querySelector(`[${DataAttribs.DATE}="${today}"]`);
    const weekdayEl = todaysEl && todaysEl.querySelector(Selectors.DATE_WEEKDAY);
    if (weekdayEl) {
        weekdayEl.textContent = 'Today';
    }
}
function getOuterWidth(el) {
    let width = el.offsetWidth;
    const style = window.getComputedStyle(el);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function scrollIntoView(container, visibleEl) {
    if (!container || !container.hasChildNodes() || !visibleEl) {
        return;
    }
    const scrollOffset = (container.clientWidth - getOuterWidth(visibleEl)) * 0.5;
    container.scrollLeft = visibleEl.offsetLeft - scrollOffset;
}
function highlightDate(containerId, selectedDate) {
    const container = document.getElementById(containerId || Selectors.DATE_PICKER_LIST);
    if (!container || !selectedDate) {
        return;
    }
    const selectedDateEl = container.querySelector(`[${DataAttribs.DATE}="${selectedDate}"]`);
    if (!selectedDateEl) {
        return;
    }
    selectedDateEl.classList.add(Styles.SELECTED_DATE);
    scrollIntoView(container, selectedDateEl);
}
module.exports = {
    highlightDate,
    markToday,
    scrollIntoView,
};
export default module.exports;